import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isDeleteTimeRecordRequestPending({ uuid }) {
      const req = getState().find((req) => req.timeRecord.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isDeleteTimeRecordRequestSuccess({ uuid }) {
      const req = getState().find((req) => req.timeRecord.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
    isDeleteTimeRecordRequestFailure({ uuid }) {
      const req = getState().find((req) => req.timeRecord.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
  };
}

export { createSelector };
